import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { IconPanel } from '../../../../icon-panel/icon-panel';

export const RealPropertyNoDesignLicensePanel = () => {
  const { t } = useTranslation();

  return (
    <Component>
      <IconPanel
        header={{ icon: { icon: ['fad', 'house-circle-check'], opacity: '50%', size: '8x' } }}
        responsiveness={{ compressed: false }}
      >
        {{
          title: t('onDemand.propertyBoundary.title', { ns: 'components' }),
          info: t('onDemand.noAccess', { ns: 'components' }),
        }}
      </IconPanel>
    </Component>
  );
};

const Component = styled.div`
  height: 100%;
  display: flex;
  padding: 1em;
`;
